import { Description, Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { useImperativeHandle, useState, forwardRef } from 'react';
import { Button } from '@oc-labs/wt-storybook'

const ConfirmModal = forwardRef((_, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const [payload, setPayload] = useState({
    title: '',
    text: '',
    onConfirm: () => {},
    action: () => {},
  });

  const close = () => {
    setIsOpen(false);
    setPayload({
      title: '',
      text: '',
      onConfirm: () => {},
      action: () => {},
    });
  };

  const open = ({ title, text, onConfirm, action: newAction }) => {
    setIsOpen(true);
    setPayload({ title, text, onConfirm, action: newAction });
  };

  const handleConfirm = () => {
    if (payload.onConfirm) payload.onConfirm();
    if (payload.action) payload.action();
    setIsOpen(false);
  };

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));

  return (
    <Dialog open={isOpen} onClose={close} className="relative z-50">
      <DialogBackdrop className="fixed inset-0 bg-black/30" />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <DialogPanel className="w-full max-w-md rounded-2xl bg-white px-4 py-6 shadow-xl space-y-6">
          <DialogTitle className="text-xl font-semibold text-center">
            {payload.title}
          </DialogTitle>
          <Description className="text-center text-gray-600">
            {payload.text}
          </Description>

          <div className="flex gap-4 pt-2">
            <Button
              type="tertiary"
              onClick={close}
              className="w-1/2"
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={handleConfirm}
              className="w-1/2"
            >
              Confirm
            </Button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  )
})

ConfirmModal.displayName = 'ConfirmModal'

export default ConfirmModal